import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DigitalMemoryLogService } from "../../services/digital-memory-log.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-duplicate-confirm-popup",
  templateUrl: "./duplicate-confirm-popup.component.html",
})
export class DuplicateConfirmPopupComponent implements OnInit {
  digitalLogId: number;
  digitalLogName: string;
  isLoading = false;

  constructor(
    public activeModal: NgbActiveModal,
    private digitalMemoryLogService: DigitalMemoryLogService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {}

  confirmDuplicate() {
    if (!this.digitalLogId) {
      this.toastr.error("Travel Guide ID is required", "Error");
      return;
    }

    this.isLoading = true;
    this.digitalMemoryLogService.duplicateDigitalMemoryLog(this.digitalLogId).subscribe(
      (res: any) => {
        this.isLoading = false;
        this.toastr.success("Travel Guide duplicated successfully!", "Success");
        this.activeModal.close("duplicated");
      },
      error => {
        this.isLoading = false;
        this.toastr.error((error && error.error && error.error.Message) || "Failed to duplicate travel guide", "Error");
      }
    );
  }

  cancel() {
    this.activeModal.dismiss("cancelled");
  }
}
